import React from "react";
import { Typography, Avatar } from "@mui/material";
import { getUserName } from "../../Features/Authentication/authSlice";
import { useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ButtonBase from "@mui/material/ButtonBase";
import { useDispatch } from "react-redux";
import { logout } from "../../Features/Authentication/authSlice";
import Divider from "@mui/material/Divider";
import Logout from "@mui/icons-material/Logout";
import { ListItemIcon, Box } from "@mui/material";

function getInitials(name) {
  if (!name) return "";
  return name.split(/\s+/).map((w) => w[0]).join("").toUpperCase().slice(0, 3);
}

export default function ProfileDropDown() {
  const dispatch = useDispatch();
  const user_name = useSelector(getUserName);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => {
    dispatch(logout());
    setAnchorEl(null);
  };

  const initials = getInitials(user_name);

  return (
    <div>
      <ButtonBase
        onClick={handleClick}
        aria-haspopup="menu"
        aria-expanded={open}
        sx={{
          width: 30,
          height: 30,
          borderRadius: "50%",
          backgroundColor: "rgba(253,185,64,0.16)",
          color: "#FDB940",
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "-0.02em",
          flexShrink: 0,
          transition: "background 0.2s",
          "&:hover": { backgroundColor: "rgba(253,185,64,0.26)" },
        }}
      >
        {initials}
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 2300 }}
      >
        <MenuItem disableRipple sx={{ cursor: "default", "&:hover": { background: "none" } }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px", pr: 1 }}>
            <Avatar sx={{ width: 34, height: 34, backgroundColor: "rgba(253,185,64,0.16)", color: "#FDB940", fontSize: "0.72rem", fontWeight: 700 }}>
              {initials}
            </Avatar>
            <Typography sx={{ fontSize: "0.9rem", fontWeight: 600 }}>{user_name}</Typography>
          </Box>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}
